export const getIsoDate = (date) => {
  return date
    ? new Date(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60 * 1000)
    : null;
};

export const getLocalDate = (date) => {
  if (!date) return null;
  return new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60 * 1000);
};
